module.exports = {
	"name": "tv",
	"version": "1.5.6",
	"description": "display 2d pefl game",
	"main": "index.js",
	"homepage": "https://pefl.ru/tv",
	"devDependencies": {
		"babel": "^6.23.0",
		"babel-core": "^6.25.0",
		"babel-loader": "^7.1.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-react-app": "^3.0.1",
		"babelify": "^7.3.0",
		"browserify": "^14.4.0",
		"cross-env": "^5.0.5",
		"enzyme": "^2.4.1",
		"jasmine-core": "^2.6.4",
		"karma": "^1.7.0",
		"karma-babel-preprocessor": "^6.0.1",
		"karma-browserify": "^5.1.1",
		"karma-chrome-launcher": "^2.2.0",
		"karma-jasmine": "^1.1.0",
		"karma-webpack": "^2.0.4",
		"react-addons-test-utils": "^15.3.0",
		"react-scripts": "^0.6.0",
		"watchify": "^3.9.0"
	},
	"dependencies": {
		"cubic-bezier": "^0.1.2",
		"es6-promise": "^4.0.5",
		"isomorphic-fetch": "^2.2.1",
		"jquery": "^3.2.1",
		"node-sass-chokidar": "^2.0.0",
		"npm-run-all": "^4.1.3",
		"react": "15.5.3",
		"react-dom": "15.5.3",
		"react-draggable": "^2.2.6",
		"react-redux": "^4.4.5",
		"react-resizable": "^1.7.5",
		"react-router": "^3.0.2",
		"react-scripts": "1.0.11",
		"react-string-replace": "^0.4.0",
		"react-three-renderer": "3.1.0",
		"recharts": "^1.0.0-alpha.2",
		"redux": "^3.5.2",
		"redux-logger": "^2.8.1",
		"redux-saga": "^0.15.6",
		"redux-thunk": "^2.2.0",
		"socket.io-client": "^2.0.3",
		"soundmanager2": "^2.97.20170602",
		"stats-js": "^1.0.0-alpha1",
		"three": "^0.84.0",
		"three-mtl-loader": "^1.0.1",
		"three-obj-loader": "^1.1.2",
		"vector2d": "^2.1.0"
	},
	"scripts": {
		"start-js": "react-scripts start",
		"start": "npm-run-all -p watch-css start-js",
		"build-js": "cross-env GENERATE_SOURCEMAP=false react-scripts build",
		"build": "npm-run-all build-css build-js",
		"eject": "react-scripts eject",
		"test": "react-scripts test",
		"build-css": "node-sass-chokidar src/ -o src/",
		"watch-css": "npm run build-css && node-sass-chokidar src/ -o src/ --watch --recursive"
	},
	"activationEvents": [
		"workspaceContains:node_modules/.bin/jest",
		"workspaceContains:node_modules/react-scripts/node_modules/.bin/jest",
		"onCommand:io.orta.jest.start"
	],
	"repository": {
		"type": "git",
		"url": "pefl_tv"
	},
	"keywords": [
		"2d"
	],
	"author": "",
	"license": "ISC"
};


/*****************
 ** WEBPACK FOOTER
 ** ./package.json
 ** module id = 703
 ** module chunks = 0
 **/